// extracted by mini-css-extract-plugin
module.exports = {"divider":"textDivider_divider__nMzr2","line":"textDivider_line__3j8cs","text":"textDivider_text__3n6Ao"};